import api from "../../../utils/api";

// Create Filter
export const createFilter = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  const res = await api.post("/filters/", payload);
  return res.data;
};

// Read Filter by ID
export const readFilter = async (publicId) => {
  if (!publicId) throw new Error("Missing or invalid ID for Filter");
  const res = await api.get(`/filters/${publicId}`);
  return res.data;
};

// Read list of Filters
export const readFilters = async (params) => {
  const res = await api.get("/filters", params ? { params } : {});
  return res.data;
};

// Update Filter
export const updateFilter = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  if (!payload.public_id) throw new Error("Missing or invalid ID for Filter");
  const res = await api.put(`/filters/${payload.public_id}`, payload);
  if (process.env.NODE_ENV === "development") console.log(res.data);
  return res.data;
};

// Delete Filter
export const deleteFilter = async (publicId) => {
  if (process.env.NODE_ENV === "development") console.log(publicId);
  if (!publicId) throw new Error("Invalid ID for Filter!");
  return await api.delete(`/filters/${publicId}`);
};
